import request from '../adminRequest'

export const postApi = {

  listPost (params) {
    return request.get('/post', {params: params})
  },
  createPost (data) {
    return request.post('/post', data)
  },
  updatePost (postId, data) {
    return request.put('/post/' + postId, data)
  },
  getPost (postId) {
    return request.get('/post/' + postId)
  },
  updatePostSortNum(postId, data) {
    return request.put('/post/' + postId + '/sortNum', data)
  },
  deletePost (postId) {
    return request.delete('/post/' + postId)
  },
}

export default postApi
